import React from "react";
import Layout from "../components/layout";
import { Link, graphql } from "gatsby";
import Lottie from "lottie-react";
import SuccessPathways from "../images/SuccessPathways.json";
import { FiArrowRight } from "react-icons/fi";
import BlogSectionTwo from "../components/blog-section-two";
import { GiCheckMark } from "react-icons/gi";
import { isBrowser } from "../helper/app";
import { GatsbyImage } from "gatsby-plugin-image";

export const Head = () => (
  <>
    <html lang="en" />
    <title>About | Cognitionteam - Learn About Our Company</title>
    <meta
      charset="UTF-8"
      name="description"
      content="Discover our story at Cognitionteam. From our humble beginnings to our innovative future, we're dedicated to delivering quality that exceeds expectations."
    />

    <link rel="canonical" href="https://cognitionteam.com/about/" />
  </>
);
export default function About({ data: { wpAboutusmain } }) {
  const [openTab, setOpenTab] = React.useState(0);
  const [openImg, setOpenImg] = React.useState(0);
  const { aboutmain } = wpAboutusmain;
  return (
    <Layout>
      <div className="relative w-full h-[460px] bg-blend-overlay bg-cover bg-center">
        <GatsbyImage
          className="w-full h-full absolute top-0 left-0 z-0"
          alt={aboutmain.heroSection.heroBgImg.altText}
          image={
            aboutmain.heroSection.heroBgImg.localFile.childImageSharp
              .gatsbyImageData
          }
          style={{ position: "absolute", zIndex: 0 }}
        />
        <div className="absolute w-full h-full md:h-2/3 bg-hero-section bottom-0 left-0">
          <div className="flex flex-col absolute inset-x-[30px] mx-auto bottom-10 md:inset-x-40 md:bottom-[60px] max-w-sm md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl">
            <h1 className="text-white text-2xl md:text-3xl 2md:text-4xl xl:text-5xl font-semibold">
              {aboutmain.heroSection.heroTitle &&
                aboutmain.heroSection.heroTitle}
            </h1>
            <p className="text-white text-base max-w-3xl">
              {aboutmain.heroSection.heroSubtitle &&
                aboutmain.heroSection.heroSubtitle}
            </p>
          </div>
        </div>
      </div>
      <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl  md:mx-auto my-12 md:my-24 px-3 md:px-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="col-span-1 md:pl-4 md:pr-12">
            <div className="md:pt-12">
              <h2 className="text-gray-8 text-2xl md:text-3xl 2md:text-4xl font-semibold">
                {aboutmain.inspiringVision.inspiringTitle &&
                  aboutmain.inspiringVision.inspiringTitle}
              </h2>
              <p className="text-sm mb-4">
                {aboutmain.inspiringVision.inspiringContent &&
                  aboutmain.inspiringVision.inspiringContent}
              </p>
              <h3 className="text-base font-semibold mb-1">
                {aboutmain.inspiringVision.buildingAnEthical
                  .buildingListTitle &&
                  aboutmain.inspiringVision.buildingAnEthical.buildingListTitle}
              </h3>
              {aboutmain.inspiringVision.buildingAnEthical.listSection &&
                aboutmain.inspiringVision.buildingAnEthical.listSection.map(
                  ({ list }) => (
                    <div className="grid grid-cols-1 md:grid-cols-1 text-sm">
                      <p>
                        {" "}
                        <GiCheckMark className="inline mr-2 mb-1 text-[20px] text-gray-8" />{" "}
                        {list}
                      </p>
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="col-span-1 grid grid-cols-2 gap-2">
            <div className="col-span-2 grid grid-cols-2 gap-2">
              <div className="col-span-1 flex items-end">
                <GatsbyImage
                  className="aspect-square w-full rounded bg-blend-overlay"
                  alt={"title"}
                  image={
                    aboutmain.inspiringVision.buildingImg.img1.localFile
                      .childImageSharp.gatsbyImageData
                  }
                />
              </div>
              <div className="col-span-1 flex items-end">
                <div className=" h-auto w-full aspect-video bg-color-red rounded">
                  <Lottie
                    className="w-full aspect-video mx-auto"
                    animationData={SuccessPathways}
                    loop={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-span-2">
              <GatsbyImage
                className="h-auto w-full md:w-4/5 rounded bg-blend-overlay"
                alt={"mission and vision"}
                image={
                  aboutmain.inspiringVision.buildingImg.img2.localFile
                    .childImageSharp.gatsbyImageData
                }
              />
            </div>
          </div>
        </div>
      </div>

      <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl md:mx-auto my-12 md:my-24 px-3 md:px-0">
        <div className="mb-2 md:mb-12 text-center ">
          <h2 className="text-gray-8 text-2xl md:text-3xl 2md:text-4xl font-semibold">
            {aboutmain.whyCognitionteam.sectionTitle &&
              aboutmain.whyCognitionteam.sectionTitle}
          </h2>
          <p className="text-center text-base text-black ">
            {aboutmain.whyCognitionteam.sectionSubheading &&
              aboutmain.whyCognitionteam.sectionSubheading}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-6">
          {aboutmain.whyCognitionteam.sectionCard.card &&
            aboutmain.whyCognitionteam.sectionCard.card.map(
              ({ cardTitle, cardSubtitle, cardIcon }) => (
                <div className="flex flex-col items-center text-center gap-4">
                  <img
                    className="w-[80px] aspect-square"
                    src={cardIcon.sourceUrl}
                    alt="top It Talent"
                  />
                  <h3 className="text-gray-8 text-2xl mb-0 mt-2">
                    {cardTitle}
                  </h3>
                  <p className="text-sm leading-6">{cardSubtitle}</p>
                </div>
              )
            )}
        </div>
      </div>

      <div className="w-full bg-gray-9 pb-12">
        <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl  md:mx-auto mt-12 md:mt-24 pb-12 px-3 md:px-0 py-8 md:py-0">
          <div className="grid grid-cols-2 xl:grid-cols-3 gap-3 md:gap-6">
            <div className="hidden xl:block relative col-span-1 mt-6 md:mt-0 md:-translate-y-16 w-full h-[600px]">
              <GatsbyImage
                className="h-full w-full rounded"
                alt={"Logistics"}
                image={
                  aboutmain.expertiseThatElevates.section2.bgImg1.localFile
                    .childImageSharp.gatsbyImageData
                }
                style={{ position: "absolute", zIndex: 0 }}
              />
            </div>
            <div className="col-span-3 lg:col-span-2 gap-3 md:gap-6">
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 md:gap-6 mt-12 mb-3">
                <div className="col-span-1">
                  <h2 className="text-white text-2xl">
                    {aboutmain.expertiseThatElevates.section1.sectionTitle1 &&
                      aboutmain.expertiseThatElevates.section1.sectionTitle1}
                  </h2>
                  <p className="text-white/70 font-medium">
                    {aboutmain.expertiseThatElevates.section1
                      .sectionSubtitle1 &&
                      aboutmain.expertiseThatElevates.section1.sectionSubtitle1}
                  </p>
                </div>
                <div className="relative col-span-1 aspect-[3/2] mt-4 my-6">
                  <GatsbyImage
                    className="h-full w-full rounded"
                    alt={"Logistics"}
                    image={
                      aboutmain.expertiseThatElevates.section2.bgImg2.localFile
                        .childImageSharp.gatsbyImageData
                    }
                    style={{ position: "absolute", zIndex: 0 }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
                <div className="col-span-2 text-white">
                  <h3 className="text-base font-medium mb-2">
                    {aboutmain.expertiseThatElevates.section1.sectionTitle2 &&
                      aboutmain.expertiseThatElevates.section1.sectionTitle2}
                  </h3>
                  <p className="mb-2 text-white/70">
                    {aboutmain.expertiseThatElevates.section1
                      .sectionSubtitle2 &&
                      aboutmain.expertiseThatElevates.section1.sectionSubtitle2}
                  </p>
                </div>
                <div className="col-span-1">
                  <ul className="flex flex-col text-sm text-white font-bold gap-4 justify-end mt-8">
                    {aboutmain.expertiseThatElevates.section3.list &&
                      aboutmain.expertiseThatElevates.section3.list.map(
                        ({ serialNo, listType }) => (
                          <li>
                            <span className="text-color-red mr-2">
                              {serialNo}
                            </span>
                            {listType}
                          </li>
                        )
                      )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-gray-9 md:mx-auto my-12 md:mt-24 mb-[420px] md:mb-[550px] lg:mb-[470px] xl:mb-[320px] py-12 md:py-24 md:px-3 md:px-0 h-[300px] ">
        <div className="mb-2 md:mb-12 text-center px-3 md:px-0">
          <h2 className="text-white text-2xl md:text-3xl 2md:text-4xl font-semibold">
            {aboutmain.buildingOnFoundation.sectionTitle &&
              aboutmain.buildingOnFoundation.sectionTitle}
          </h2>
        </div>
        <div className="w-full bg-center bg-cover mb-12 md:mb-24">
          <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl md:mx-auto">
            {isBrowser && window.innerWidth >= 750 ? (
              <div className="hidden md:block md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-3 md:px-0  md:mx-auto">
                <div className="grid grid-cols-12 shadow-lg rounded-lg overflow-visible">
                  <div className="col-span-12 h-full">
                    <>
                      <ul className="flex flex-row flex-wrap justify-center xl:grid xl:grid-cols-6">
                        {aboutmain.buildingOnFoundation.cardSection.card &&
                          aboutmain.buildingOnFoundation.cardSection.card.map(
                            ({ title, icon, iconHover }, index) => (
                              <li>
                                <Link
                                  className={
                                    "group cursor-pointer border-[1px] w-full h-[150px] aspect-[6/5] border-white/5  md:hover:scale-[1.05] hover:shadow-xl ease-out duration-200 flex flex-col justify-center items-center text-center snap-center hover:bg-white hover:text-color-red hover:z-10 hover:rounded" +
                                    (openTab === index
                                      ? " scale-[1.07] shadow-xl ease-out duration-200 bg-white text-color-red backdrop-blur-sm z-20 rounded border-[5px] border-white/5 "
                                      : " border-color-red/10 bg-white text-gray-8 z-10")
                                  }
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpenTab(index);
                                  }}
                                  data-toggle="tab"
                                  to="#link1"
                                  role="tablist"
                                >
                                  <div className="flex flex-col gap-4 justify-center items-center">
                                    <img
                                      className="h-14 w-14 "
                                      src={
                                        openTab === index
                                          ? iconHover.sourceUrl
                                          : icon.sourceUrl
                                      }
                                      alt={icon.altText}
                                      id={`our-value-${index}`}
                                    />
                                    <h3 className="text-base m-0">{title}</h3>
                                  </div>
                                </Link>
                              </li>
                            )
                          )}
                      </ul>
                    </>
                  </div>
                  <div className="col-span-12 relative w-full rounded-lg text-center">
                    <div className="w-full h-full text-body-color p-12">
                      <>
                        {aboutmain.buildingOnFoundation.cardSection.card &&
                          aboutmain.buildingOnFoundation.cardSection.card.map(
                            ({ subtitle }, index) => (
                              <div
                                className={
                                  openTab === index
                                    ? "inline-block w-full "
                                    : "hidden"
                                }
                                role="presentation"
                                id={index}
                              >
                                <p className="text-body-color">{subtitle}</p>
                              </div>
                            )
                          )}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full flex flex-row overflow-scroll snap-x snap-mandatory md:hidden pt-0 pb-8">
                {aboutmain.buildingOnFoundation.cardSection.card &&
                  aboutmain.buildingOnFoundation.cardSection.card.map(
                    ({ title, icon, subtitle }, index) => (
                      <div className=" shrink-0 snap-center mx-2 w-[340px] shadow-xl rounded-xl bg-white px-3 py-4">
                        <div
                          className="w-full h-full px-3 py-6 rounded-xl bg-white/10 backdrop-blur"
                          onClick={(e) => {}}
                          role="presentation"
                        >
                          <div className="flex flex-row items-center justify-between pb-4">
                            <div>
                              <h3 className="text-2xl text-gray-8 mb-1">
                                {title}
                              </h3>
                              <div className="border border-2 border-gray-8/10 w-12"></div>
                            </div>

                            <img
                              className="h-[60px] aspect-square"
                              src={icon.sourceUrl}
                              alt={icon.altText}
                              id={index}
                            />
                          </div>

                          <p>{subtitle}</p>
                        </div>
                      </div>
                    )
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="relative z-20 w-full bg-center bg-cover mb-12 md:mb-24"
        // style={{ backgroundImage: `url(${coverImage})` }}
      >
        <GatsbyImage
          className="w-full h-full absolute top-0 left-0 z-0"
          alt={"title"}
          image={
            aboutmain.driveSuccess.cardSection.card[openImg].cardBgImg.localFile
              .childImageSharp.gatsbyImageData
          }
          style={{ position: "absolute", zIndex: 0 }}
        />
        <div className="relative z-20 w-full h-full bg-gradient-to-b from-black via-black/80 to-black/50 py-24">
          <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl md:mx-auto px-3 md:px-0">
            <div className="mb-12 text-center overflow-visible">
              <h2 className="text-white text-2xl md:text-4xl">
                {aboutmain.driveSuccess.sectionTitle &&
                  aboutmain.driveSuccess.sectionTitle}
              </h2>
              <p className="text-center text-base md:text-lg text-white">
                {aboutmain.driveSuccess.sectionSubtitle &&
                  aboutmain.driveSuccess.sectionSubtitle}
              </p>
            </div>
            <ul className="flex flex-row snap-x snap-mandatory overflow-x-scroll md:overflow-visible md:grid md:grid-cols-4 gap-3 md:gap-2">
              {aboutmain.driveSuccess.cardSection.card &&
                aboutmain.driveSuccess.cardSection.card.map(
                  ({ cardTitle, cardIcon, cardIconHover }, index) => (
                    <li
                      className="group border-[2px] aspect-[6/3] border-white/10  md:w-full h-[150px] md:hover:scale-[1.05] hover:shadow-2xl ease-out duration-200 rounded flex justify-center items-center p-6 text-center snap-center hover:bg-black/50 hover:text-white"
                      onMouseEnter={() => {
                        setOpenImg(index);
                        window.document.getElementById(
                          `indu-home-${index}`
                        ).src = cardIconHover.sourceUrl;
                      }}
                      onMouseLeave={() => {
                        window.document.getElementById(
                          `indu-home-${index}`
                        ).src = cardIcon.sourceUrl;
                      }}
                      role="presentation"
                    >
                      <div className="flex flex-col items-center p-2">
                        <img
                          className="w-16 h-16 mb-2"
                          src={cardIcon.sourceUrl}
                          alt={cardTitle}
                          id={`indu-home-${index}`}
                        />
                        <h5 className="text-sm group-hover:text-white shadow-card-1 font-semibold uppercase">
                          {cardTitle}
                        </h5>
                      </div>
                    </li>
                  )
                )}
            </ul>
          </div>
        </div>
      </div>
      <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-3 md:px-0 mb-16 md:mb-24 md:mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-12 mb-12 border-b border-black/10">
          <div className="cols-span-1">
            <h2 className="text-gray-8 text-2xl md:text-4xl">
              {aboutmain.ourPricnigPolicy.sectionTitle &&
                aboutmain.ourPricnigPolicy.sectionTitle}
            </h2>
            <p className="md:text-lg text-black mb-2">
              {aboutmain.ourPricnigPolicy.sectionSubtitle &&
                aboutmain.ourPricnigPolicy.sectionSubtitle}
            </p>
            <ul className="flex flex-col gap-3">
              {aboutmain.ourPricnigPolicy.sectionList.list &&
                aboutmain.ourPricnigPolicy.sectionList.list.map(
                  ({ serialNo, listType }) => (
                    <li className="flex flex-row items-center gap-3">
                      <span className="text-sm p-2 text-color-red bg-gray-1 w-9 h-9 rounded-full font-bold flex justify-center items-center">
                        {serialNo}
                      </span>
                      <p>{listType}</p>
                    </li>
                  )
                )}
            </ul>
          </div>
          <div className="relative col-span-1 aspect-video rounded overflow-hidden">
            <GatsbyImage
              className="h-full w-full"
              alt={"pricing models"}
              image={
                aboutmain.ourPricnigPolicy.sectionBgImg.localFile
                  .childImageSharp.gatsbyImageData
              }
              style={{ position: "absolute", zIndex: 0 }}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="col-span-1 grid grid-cols-1 xl:grid-cols-2 gap-4">
            <div className="col-span-1 flex flex-col gap-4">
              <div className="relative w-full aspect-video xl:aspect-[6/4] rounded overflow-hidden">
                <GatsbyImage
                  className="h-full w-full"
                  alt={"pricing models"}
                  image={
                    aboutmain.boostProductivity.sectionCard.bgImg1.localFile
                      .childImageSharp.gatsbyImageData
                  }
                  style={{ position: "absolute", zIndex: 0 }}
                />
                <div className="relative w-full h-full bg-gradient-to-t from-black via-black/50 to-transparent z-20 flex flex-col justify-end ">
                  <h4 className="text-lg text-white px-4">
                    {aboutmain.boostProductivity.sectionCard.bgImgText1 &&
                      aboutmain.boostProductivity.sectionCard.bgImgText1}
                  </h4>
                </div>
              </div>
              <div className="relative w-full aspect-video xl:aspect-[5/4] rounded overflow-hidden ">
                <GatsbyImage
                  className="h-full w-full"
                  alt={"Adoption of new technologies"}
                  image={
                    aboutmain.boostProductivity.sectionCard.bgImg2.localFile
                      .childImageSharp.gatsbyImageData
                  }
                  style={{ position: "absolute", zIndex: 10 }}
                />
                <div className="relative w-full h-full bg-gradient-to-t from-black via-black/40 to-transparent z-20 flex flex-col justify-end ">
                  <h4 className="text-lg text-white px-4">
                    {aboutmain.boostProductivity.sectionCard.bgImgText2 &&
                      aboutmain.boostProductivity.sectionCard.bgImgText2}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-span-1 flex flex-col gap-4">
              <div className="relative w-full aspect-video xl:aspect-[4/5] rounded overflow-hidden ">
                <GatsbyImage
                  className="h-full w-full"
                  alt={"Employee training and further education"}
                  image={
                    aboutmain.boostProductivity.sectionCard.bgImg3.localFile
                      .childImageSharp.gatsbyImageData
                  }
                  style={{ position: "absolute", zIndex: 10 }}
                />
                <div className="relative w-full h-full bg-gradient-to-t from-black via-black/40 to-transparent z-20 flex flex-col justify-end ">
                  <h4 className="text-lg text-white px-4">
                    {aboutmain.boostProductivity.sectionCard.bgImgText3 &&
                      aboutmain.boostProductivity.sectionCard.bgImgText3}
                  </h4>
                </div>
              </div>
              {/*<div className="w-full bg-color-red aspect-video rounded"></div>*/}
            </div>
          </div>
          <div className="col-span-1">
            <h3 className="text-gray-8 text-lg ">
              {aboutmain.boostProductivity.sectionTitle &&
                aboutmain.boostProductivity.sectionTitle}
            </h3>
            <p className="mb-6">
              {aboutmain.boostProductivity.sectionSubtitle &&
                aboutmain.boostProductivity.sectionSubtitle}
            </p>
            <div className="grid grid-cols-1 gap-6">
              {aboutmain.boostProductivity.sectionList.list &&
                aboutmain.boostProductivity.sectionList.list.map(
                  ({ listIcon, listText }) => (
                    <div className="col-span-1 flex flex-row gap-2 items-center">
                      <img
                        className="w-12 h-12"
                        src={listIcon.sourceUrl}
                        alt="icon"
                      />
                      <h4 className="text-base m-0 ">{listText}</h4>
                    </div>
                  )
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-1 w-full mb-12 md:mb-24">
        <div className="md:max-w-2xl 2md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-3 md:px-0 mb-16 md:mb-24 grid grid-cols-8 gap-6 md:mx-auto py-12 md:py-24">
          <div className="col-span-8 md:col-span-3">
            <div className="sticky top-20 bottom-20">
              <h2 className="text-gray-8 text-2xl md:text-3xl 2md:text-4xl font-semibold">
                {aboutmain.benefitsOfPartnering.sectionTitle &&
                  aboutmain.benefitsOfPartnering.sectionTitle}
              </h2>
              <p className="text-black text-base mb-10">
                {aboutmain.benefitsOfPartnering.sectionSubtitle &&
                  aboutmain.benefitsOfPartnering.sectionSubtitle}
              </p>
              <Link to="/services" className="btn btn-primary-round btn-round">
                {aboutmain.benefitsOfPartnering.btnTitle &&
                  aboutmain.benefitsOfPartnering.btnTitle}{" "}
                <FiArrowRight className="inline text-[24px]" />
              </Link>
            </div>
          </div>
          <div className="col-span-8 md:col-span-5">
            <div className="grid grid-cols-1 gap-3 md:gap-6">
              {aboutmain.benefitsOfPartnering.cardSection.card.map(
                ({ cardTitle, cardSubtitle, cardImg }) => {
                  return (
                    <div className="w-full col-span-1">
                      <div className="col-span-1 p-10 bg-white rounded flex flex-col items-start justify-center">
                        <img
                          className="h-[72px] mb-2 aspect-square"
                          src={cardImg.sourceUrl}
                          alt="dotnet"
                        />
                        <h3 className="text-gray-8 text-lg mb-2">
                          {cardTitle}
                        </h3>
                        <div className="border-b-2 w-full border-gray-1 mb-4"></div>
                        <p className="text text-body-color mb-0">
                          {cardSubtitle}
                        </p>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
      <BlogSectionTwo />
    </Layout>
  );
}

export const pageQuery = graphql`
  query {
    wpAboutusmain {
      aboutmain {
        heroSection {
          heroTitle
          heroSubtitle
          heroBgImg {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        inspiringVision {
          inspiringTitle
          inspiringContent
          buildingAnEthical {
            buildingListTitle
            listSection {
              list
            }
          }
          buildingImg {
            img1 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            img2 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
        whyCognitionteam {
          sectionTitle
          sectionSubheading
          sectionCard {
            card {
              cardTitle
              cardSubtitle
              cardIcon {
                sourceUrl
              }
            }
          }
        }
        expertiseThatElevates {
          section1 {
            sectionTitle1
            sectionSubtitle1
            sectionTitle2
            sectionSubtitle2
          }
          section2 {
            bgImg1 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            bgImg2 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          section3 {
            list {
              serialNo
              listType
            }
          }
        }
        buildingOnFoundation {
          sectionTitle
          cardSection {
            card {
              title
              subtitle
              icon {
                sourceUrl
              }
              iconHover {
                sourceUrl
              }
            }
          }
        }
        driveSuccess {
          sectionTitle
          sectionSubtitle
          cardSection {
            card {
              cardTitle
              cardIcon {
                sourceUrl
              }
              cardIconHover {
                sourceUrl
              }
              cardBgImg {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
        ourPricnigPolicy {
          sectionTitle
          sectionSubtitle
          sectionList {
            list {
              serialNo
              listType
            }
          }
          sectionBgImg {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        boostProductivity {
          sectionTitle
          sectionSubtitle
          sectionList {
            list {
              listText
              listIcon {
                sourceUrl
              }
            }
          }
          sectionCard {
            bgImg1 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            bgImgText1
            bgImg2 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            bgImgText2
            bgImg3 {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            bgImgText3
          }
        }
        benefitsOfPartnering {
          sectionTitle
          sectionSubtitle
          btnTitle
          cardSection {
            card {
              cardTitle
              cardSubtitle
              cardImg {
                sourceUrl
              }
            }
          }
        }
      }
    }
  }
`;
